import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MedicalProvider } from '../../models/commonmodel';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MemberInsurerRestService } from '../../services/member-insurer-rest.service';
import { NotificationService } from '../shared/services/notifications.service';
import { LoaderComponent } from "../shared/loader/loader.component";
import { MemberInsurerServiceService } from '../../services/member-insurer-service.service';
import { StatusLablesComponent } from "../shared/components/status-lables/status-lables.component";
import { EntityType } from '../shared/share';
import { NoDataFoundComponent } from "../shared/no-data-found/no-data-found.component";
import { masterProvider } from '../../models/phase1models';

@Component({
  selector: 'app-medical-provider-list',
  standalone: true,
  imports: [CommonModule, MatIconModule, LoaderComponent, StatusLablesComponent, NoDataFoundComponent],
  templateUrl: './medical-provider-list.component.html',
  styleUrl: './medical-provider-list.component.scss',
})
export class MedicalProviderListComponent {

  constructor(public dialogRef: MatDialogRef<MedicalProviderListComponent>, private restService: MemberInsurerRestService,
    private notificationService: NotificationService, private memberService: MemberInsurerServiceService
  ) {

  }

  popupTitle = 'Add Medical Evidence Provider';
  popupSubtitle = 'Add or link a Medical Evidence Provider (MEP) you rely on.';

  isLoding: boolean = false;
  enumEntityType = EntityType;
  masterMedicalProviderList: masterProvider[] = [];
  copiedEmail: string | null = null;
  isDataLoading: boolean = false;

  ngOnInit(): void {
    this.getAllMasterMEPs();
  }

  getAllMasterMEPs() {
    this.isDataLoading = true;
    this.restService.getAllMasterMEPs().subscribe({
      next: (response) => {
        if (response) {
          this.masterMedicalProviderList = response;
        }
        this.isDataLoading = false;
      },
      error: (error) => {
        this.masterMedicalProviderList = [];
        this.isDataLoading = false;
      }
    });
  }

  onClose() {
    this.dialogRef.close();
  }

  copyToClipboard(value: string) {
    navigator.clipboard.writeText(value);
    this.copiedEmail = value;
    setTimeout(() => {
      this.copiedEmail = null;
    }, 1200);
  }

  onSelectProvider(provider: masterProvider) {
    let reqBody = {
      "providerId": provider.masterProviderId,
      "insurerId": this.memberService.getLoginUserId()
    }
    this.restService.addMEPtoInsurer(reqBody).subscribe({
      next: (response) => {
        this.notificationService.showNotification('Provider added successfully');
      },
      error: (error) => {
        this.notificationService.showNotification(error.error.Message, 'error');
      }
    });
  }
}
